<template>
  <div class="page-main" v-if="loaded">
    <e-tabs :list="this.$constant.tabListLocation()" :activeVal.sync="tabActive" />
    <DetailArea v-if="tabActive === '0'" :parentId="detailId" />
    <DetailSite v-if="tabActive === '1'" :parentId="detailId" />
  </div>
</template>

<script>
import DetailArea from './common/detail-area'
import DetailSite from './common/detail-site'
export default {
  components: {
    DetailArea,
    DetailSite
  },
  data() {
    return {
      loaded: false,
      detailId: '',
      tabActive: ''
    }
  },
  watch: {
    tabActive(newVal, oldVal) {
      if (newVal && oldVal) {
        let url = `/company/jiagou/location/detail?id=${this.detailId}&type=${newVal}`
        this.$router.push(url)
      }
    }
  },
  mounted() {
    this.loaded = false
    let { id, type } = this.$route.query
    if (id) this.detailId = id
    if (type) this.tabActive = type
    this.loaded = true
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
